const roles = {
  ADMIN: 'ROLE_ADMIN',
  PROVINCE: 'ROLE_PROVINCE',
  DISTRICT: 'ROLE_DISTRICT',
  WARD: 'ROLE_WARD'
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else {
    //   return '/user-management/managed-users';
    // }
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/devices-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/files-screen-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/schedule-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/history-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/administrator*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/administrator\/pi-action-config.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/thread.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    }
  ]
}
